import type { ReactNode } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useRouterQuery from '@/hooks/utils/useRouterQuery';

// Types
import type { SettingsSubMenuEntryType } from '@/lib/platform/settings/menu/menu';
// Lib
import { settingsMenu } from '@/lib/platform/settings/menu/menu';

// Components
import Icon from '@/components/base/Icon';

export type SettingsHeaderProps = {
    children?: ReactNode;
};

export function SettingsHeader({ children }: SettingsHeaderProps) {
    const { t } = useTranslation('settings');
    const { deleteAllQueries } = useRouterQuery();
    const urlWithoutParams = deleteAllQueries();

    let activeEntry: SettingsSubMenuEntryType;

    for (const settingsMenuEntry of settingsMenu) {
        for (const settingsMenuSubEntry of settingsMenuEntry.subMenuItems) {
            if (settingsMenuSubEntry.link === urlWithoutParams) {
                activeEntry = settingsMenuSubEntry;
                break;
            }
        }
        if (activeEntry) {
            break;
        }
    }

    return (
        <div className="mb-8 flex w-full flex-row flex-wrap items-center justify-between gap-3">
            <div className="flex-1">
                <p className="text-8 uppercase tracking-0.5 text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t('my_account')}
                </p>
                {activeEntry ? (
                    <p
                        className="mt-3 flex flex-row items-center space-x-2 text-2xl"
                        data-testid="settings-header-subtitle">
                        <Icon icon={activeEntry.icon} className="text-icoBlue" />
                        <span>{t(activeEntry.title)}</span>
                    </p>
                ) : null}
            </div>
            {children}
        </div>
    );
}
